import React, { createContext, useContext } from "react"
import { SubmitHandler } from "react-hook-form"
import { DriverInfo, IFormFilterDriver, VehicleInfo } from "types/list-card-holder"
import { SortOrder } from "types/sort.ts"

interface DriversContextType {
    apiSuccess: boolean | null
    listDrivers: DriverInfo[]
    listVehicles: VehicleInfo[]
    filteredDrivers: DriverInfo[] | VehicleInfo[]
    sortedDrivers: DriverInfo[] | VehicleInfo[]
    sortOrder: SortOrder
    orderByDriver: keyof DriverInfo
    orderByVehicle: keyof VehicleInfo
    isLoading: boolean
    isRefetchingList: boolean
    isVehicle: boolean
    openAddCardHolder: boolean
    openUpdateCardHolder: boolean
    openActivateCardHolder: boolean
    openDeactivateCardHolder: boolean
    setOpenAddCardHolder: React.Dispatch<React.SetStateAction<boolean>>
    setOpenUpdateCardHolder: React.Dispatch<React.SetStateAction<boolean>>
    setOpenActivateCardHolder: React.Dispatch<React.SetStateAction<boolean>>
    setOpenDeactivateCardHolder: React.Dispatch<React.SetStateAction<boolean>>
    onClosePopup: () => void
    onFilterSubmit: SubmitHandler<IFormFilterDriver>
    defaultFilterValues: IFormFilterDriver
    filterValues: IFormFilterDriver | null
    setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>
    setOrderByDriver: React.Dispatch<React.SetStateAction<keyof DriverInfo>>
    setOrderByVehicle: React.Dispatch<React.SetStateAction<keyof VehicleInfo>>
    setIsVehicle: React.Dispatch<React.SetStateAction<boolean>>
    fetchListDrivers: RequestFunction
    driverSelected: DriverInfo | VehicleInfo | null
    setDriverSelected: React.Dispatch<
        React.SetStateAction<DriverInfo | VehicleInfo | null>
    >
    updatedCardHolderId: string | null
    setUpdatedCardHolderId: React.Dispatch<React.SetStateAction<string | null>>
    pageNumber: number
    numberOfPages: number
    currentRows: DriverInfo[] | VehicleInfo[]
    handleChangePage: (_event: React.ChangeEvent<unknown>, page: number) => void
    noResultFilter: boolean
}

export const DriversPageContext = createContext<DriversContextType | undefined>(
    undefined
)

export const useCardHolderContext = () => {
    const context = useContext(DriversPageContext)
    if (context === undefined) {
        throw new Error(
            "useDriversContext doit être utilisé à l'intérieur de CardHolderPageProvider"
        )
    }
    return context
}
